import { Component, OnInit } from '@angular/core';
import { ScheduleStateService } from '../services/schedule-state.service';

@Component({
  selector: 'app-page-schedules',
  templateUrl: './page-schedules.component.html',
  styleUrls: ['./page-schedules.component.css']
})
export class PageSchedulesComponent implements OnInit {

  constructor(
    private scheduleStateService: ScheduleStateService,
  ) { }

  ngOnInit(): void {
  }
  
  get schedulePlanTitle(): string {
    return this.scheduleStateService.schedulePlanTitle;
  }

  get schedulePlanDescription(): string {
    return this.scheduleStateService.schedulePlanDescription;
  }
}
